import Helpers from "./../helpers/utility";
var isObject = Helpers.isObject, clone = Helpers.clone, isPropertyLessObject = Helpers.isPropertyLessObject, hasProperties = Helpers.hasProperties, isEqual = Helpers.isEqual;
/**
 * Private helper for deepAssign and deepUpdate
 *
 * @param {object} target The target objects
 * @param {Array<object>} sources The source object(s)
 * @param {DeepMergeOptions} options Options for mapping
 */
export default function deepMerge(target, sources, options) {
    if (options === void 0) { options = {}; }
    var out = options.noAssign ? {} : target;
    sources.filter(Helpers.isObject).forEach(function (source) {
        Object.keys(source).forEach(function (key) {
            if (options.updateOnly && !target[key])
                return;
            var value = source[key];
            if (isObject(value)) {
                var newValue = void 0;
                if (!target[key]) {
                    newValue = clone(value);
                }
                else {
                    newValue = deepMerge(target[key], [value], options);
                }
                if (hasProperties(newValue) ||
                    isPropertyLessObject(newValue) ||
                    !target[key]) {
                    out[key] = newValue;
                }
            }
            else {
                if (!options.changedOnly || !isEqual(target[key], value)) {
                    out[key] = value;
                }
            }
        });
    });
    return out;
}
//# sourceMappingURL=deep-merge.js.map